import { WorkstationDowntimeModel } from "./workstation-downtime.model";


export class ReasonWiseDowntimeModel {
    reasonId: string;
    criticality: string;
    workstationWiseIdleTimes: WorkstationDowntimeModel[];

    constructor(reasonId: string,
        criticality: string,
        workstationWiseIdleTimes: WorkstationDowntimeModel[]) {
            this.reasonId = reasonId;
            this.criticality = criticality;
            this.workstationWiseIdleTimes = workstationWiseIdleTimes;
    }
}